<template>
  <div>
    <!-- input search -->
    <div class="custom-search d-flex justify-content-end">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Recherche</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Recherche"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group>
      <b-form-group>
        <b-button
          :to="{ name: 'create-product' }"
          variant="gradient-primary"
          class="ml-1 d-inline-block"
        >
          <feather-icon icon="PlusIcon" />
          <span class="ml-1">Ajouter un produit</span>
        </b-button>
      </b-form-group>
    </div>
    <div
      v-if="isLoading"
      class="text-center mb-2"
    >
      <b-spinner
        variant="primary"
        label="Text Centered"
      />
    </div>
    <!-- table -->
    <vue-good-table
      style-class="vgt-table striped bordered condensed"
      :columns="columns"
      :rows="products"
      :rtl="direction"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >

        <!-- Column: image -->
        <div
          v-if="props.column.field === 'image'"
          class="text-nowrap"
        >
          <b-img-lazy
            :src="`https://res.cloudinary.com/groupe-service-rapide/${props.row.image}`"
            class="mx-1"
            width="150px"
            height="100px"
            fluid
          />
        </div>

        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span>
            <router-link
              class="text-success"
              :to="{ name: 'edit-product',
                     params: { id: props.row.id} }"
            >  <feather-icon
              :id="`invoice-row-${props.row.id}-edit-icon`"
              icon="EditIcon"
              class="cursor-pointer mr-1"
              size="16"
            /></router-link>

            <b-tooltip
              title="Modifier"
              class="cursor-pointer"
              :target="`invoice-row-${props.row.id}-edit-icon`"
            />

            <router-link
              class="text-success"
              :to="{ name: 'print-product',
                     params: { id: props.row.id} }"
            > <feather-icon
              :id="`invoice-row-${props.row.id}-show-icon`"
              icon="PrinterIcon"
              class="cursor-pointer mr-1"
              size="16"
            /></router-link>
            <b-tooltip
              title="Imprimer ticket"
              class="cursor-pointer"
              :target="`invoice-row-${props.row.id}-show-icon`"
            />
          </span>
          <span>
            <feather-icon
              :id="`invoice-row-${props.row.id}-trash-icon`"
              icon="TrashIcon"
              color="red"
              class="cursor-pointer"
              size="16"
              @click="deleteProduct(props.row)"
            />
            <b-tooltip
              title="Supprimer"
              class="cursor-pointer"
              :target="`invoice-row-${props.row.id}-trash-icon`"
            />
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              Affichage 1 à
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['10','15','25']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap "> {{ props.total }} résultats trouvés </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import {
  BPagination, BFormGroup, BFormInput, BFormSelect, BButton,
  BSpinner, BTooltip, BImgLazy,

} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store/index'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    VueGoodTable,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BSpinner,
    BTooltip,
    BImgLazy,
  },
  data() {
    return {
      isLoading: false,
      pageLength: 15,
      dir: false,
      columns: [
        {
          label: 'Reference',
          field: 'reference',
          filterOptions: {
            enabled: true,
            placeholder: 'Reference',
          },
        },
        {
          label: 'Produit',
          field: 'name',
          filterOptions: {
            enabled: true,
            placeholder: 'Produit',
          },
        },
        {
          label: 'Prix de vente',
          field: 'sales_price_ttc',
          filterOptions: {
            enabled: true,
            placeholder: 'Prix de vente',
          },
        },
        {
          label: 'Quantité',
          field: 'quantity',
          filterOptions: {
            enabled: true,
            placeholder: 'Quantité',
          },
        },
        {
          label: 'Fournisseur',
          field: 'supplier',
          filterOptions: {
            enabled: true,
            placeholder: 'Fournisseur',
          },
        },
        {
          label: 'Categorie',
          field: 'category',
          filterOptions: {
            enabled: true,
            placeholder: 'categorie',
          },
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
      searchTerm: '',
    }
  },
  computed: {
    ...mapGetters('product', ['products']),
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  created() {
    this.getProducts()
  },
  methods: {
    ...mapActions('product', ['getProducts']),
    async deleteProduct(payload) {
      const title = `Êtes-vous sûr de vouloir supprimer le produit? ${payload.name}`
      const result = await this.$swal({
        title,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Oui, je veux supprimer ce produit',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
      this.isLoading = true
      if (result.value) {
        await store.dispatch('product/deleteProduct', payload.id)
        this.isLoading = false
      } else if (result.dismiss === 'cancel') {
        this.isLoading = false
        this.$swal({
          title: 'Fermer',
          text: 'Produit non supprimé',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success',
          },
        })
      }
    },
    // toast
    showToast(variant, position, text) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Notification',
            icon: 'InfoIcon',
            text,
            variant,
          },
        },
        {
          position,
        },
      )
    },
  },
}
</script>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
